module.exports = __webpack_public_path__ + "img/6-6.89490ffc.svg";